import { createEnergyQuoteEligibilityUrl } from '@/src/constants/endpoints';
import { apiService } from '@/src/services/api-service';
import { useQuery, UseQueryOptions } from 'react-query';
import {
  EnergyQuoteEligibility,
  EnergyAcquisitionFuelType,
} from '../types/EnergyQuote';

type EnergyEligibilityQuoteParams = {
  postCode: string;
  propertySearchId: string;
  region?: string;
};

function useEnergyQuoteEligibility(
  params: EnergyEligibilityQuoteParams,
  options: UseQueryOptions<EnergyQuoteEligibility>,
) {
  return useQuery<EnergyQuoteEligibility>(
    ['energy-quote-eligibility', params],
    () =>
      apiService.get<EnergyQuoteEligibility>({
        url: createEnergyQuoteEligibilityUrl(
          new URLSearchParams({
            postcode: params?.postCode,
            propertySearchId: params?.propertySearchId,
            requestedFuel: EnergyAcquisitionFuelType.Dual,
            ...(params.region ? { region: params.region } : {}),
          }),
        ),
        headers: {
          'x-ovo-gemini-flags': 'enable00ProfileClass:true',
        },
      }),
    options,
  );
}

export { useEnergyQuoteEligibility };
